import { render } from "./ComplianceReviewSection.vue?vue&type=template&id=d1fe4b82&ts=true"
import script from "./ComplianceReviewSection.vue?vue&type=script&lang=ts"
export * from "./ComplianceReviewSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__